export const CreateNewPage = () => {
    return (
        <h1>CreateNewPage</h1>
    );
};